<template>
<div>
    <h1>Nationale Défilé 2014</h1>
    <p>
        Op de nationale défilé in 2014 maakten we deel uit van het historisch detachement 14-18 ter nagedachtenis van WOI. Hieronder kan u een stuk uit de uitzending van Canvas herbekijken.
    </p>
    <br />
    <div class="video">
          <video width="960" height="720" controls>
          <source :src="defile" type="video/mp4">
          Uw browser ondersteunt geen video.
        </video> 
    </div>
</div>
  
</template>

<script>
export default {
    name: 'Defile',
    data: function() {
        return {
            defile: process.env.VUE_APP_VIDEO_URL + '/defile.mp4'
        }
    }
}
</script>

<style scoped>
h1 {
    margin-top: 1em;
    color: #016F70;
    font-weight: 600;
    font-size: 1.3em;
}
.video {
    text-align: center;

}
</style>
